import $api from "../http";
import { ISettings } from "../models/Settings";

class SettingsServiceClass {
  getSettings() {
    return $api.get<ISettings>(`api/settings`);
  }
}

export const SettingsService = new SettingsServiceClass();
